/* Elemence Hero — scroll parallax on .elemence-hero__bg.
   Mirrors React app: sets --hero-bg-parallax-y = scrollY * factor (rAF-throttled). */
(function () {
  const FACTOR = 0.15;

  function init() {
    const wrap = document.querySelector('.elemence-hero__bg');
    if (!wrap) return;

    let raf = 0;
    const update = () => {
      wrap.style.setProperty('--hero-bg-parallax-y', `${window.scrollY * FACTOR}px`);
      raf = 0;
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('.elemence-hero__bg')) {
      init();
    }
  });
})();
